module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-container"
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_2",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "310.548px",
      "height": "50.507px",
      "viewBox": "0 0 310.548 50.507",
      "enable-background": "new 0 0 310.548 50.507",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    staticClass: "projects-path",
    attrs: {
      "d": "M24.377,3.979c10.853,0.254,14.602,7.067,13.637,14.124c-1.871,13.673-16.709,14.608-22.867,14.698l-2.104,15.561\n  \t\tc-0.054,0.4-0.468,0.662-0.752,0.662H2.329c-0.401,0-0.611-0.379-0.573-0.662L7.667,4.642c0.054-0.4,0.467-0.662,0.752-0.662\n  \t\tH24.377z M3.17,47.699h8.638l2.103-15.554c0.043-0.322,0.369-0.66,0.747-0.662c6.104-0.044,20.293-0.68,22.031-13.383\n  \t\tc0.875-6.396-2.348-12.559-12.506-12.797H8.902L3.17,47.699z M14.986,24.196l1.569-11.605c0.039-0.284,0.351-0.662,0.752-0.662\n  \t\tc5.693,0,10.933,0.999,10.171,6.494c-0.811,5.85-7.201,6.334-11.905,6.436C15.185,24.867,14.938,24.552,14.986,24.196z\n  \t\t M26.154,18.418c0.555-4.005-2.91-5.077-8.364-5.159l-1.387,10.258C21.229,23.362,25.571,22.62,26.154,18.418z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "projects-path",
    attrs: {
      "d": "M62.061,3.979c10.854,0.254,14.602,7.067,13.637,14.124c-0.898,6.561-4.88,10.255-9.392,12.261l9.216,17.633\n  \t\tc0,0,0.589,1.027-0.692,1.027h-10.97c-0.225,0-0.423-0.125-0.514-0.3l-8.313-15.993c-0.872,0.044-1.623,0.062-2.202,0.07\n  \t\tl-2.104,15.561c-0.054,0.4-0.468,0.662-0.752,0.662h-9.963c-0.401,0-0.611-0.379-0.573-0.662L45.35,4.642\n  \t\tc0.054-0.4,0.467-0.662,0.752-0.662H62.061z M40.853,47.699h8.638l2.103-15.554c0.043-0.322,0.369-0.66,0.747-0.662\n  \t\tc0.888-0.006,1.971-0.025,3.178-0.096c0.203-0.012,0.446,0.094,0.553,0.299l8.324,16.013h9.383l-9.02-17.26\n  \t\tc-0.318-0.608,0.247-0.903,0.429-0.976c4.475-1.775,8.318-5.027,9.185-11.363c0.875-6.396-2.348-12.559-12.506-12.797H46.585\n  \t\tL40.853,47.699z M52.669,24.196l1.569-11.605c0.039-0.284,0.351-0.662,0.752-0.662c5.692,0,10.933,0.999,10.171,6.494\n  \t\tc-0.811,5.85-7.201,6.334-11.905,6.436C52.868,24.867,52.621,24.552,52.669,24.196z M63.837,18.418\n  \t\tc0.555-4.005-2.91-5.077-8.364-5.159l-1.387,10.258C58.913,23.362,63.254,22.62,63.837,18.418z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "projects-path",
    attrs: {
      "d": "M105.699,3.185c12.683,0,21.215,10.652,19.506,23.291c-1.708,12.637-13.126,23.344-25.811,23.344\n  \t\tc-12.683,0-21.26-10.704-19.551-23.344C81.552,13.834,93.019,3.185,105.699,3.185z M99.573,48.494\n  \t\tc11.905,0,22.691-10.067,24.307-22.019c1.616-11.95-6.454-21.967-18.36-21.967c-11.908,0-22.738,10.019-24.353,21.967\n  \t\tC79.552,38.425,87.667,48.494,99.573,48.494z M104.324,13.359c7.171,0,11.935,5.99,10.972,13.116\n  \t\tc-0.963,7.123-7.35,13.169-14.525,13.169c-7.173,0-11.981-6.042-11.018-13.169C90.716,19.346,97.155,13.359,104.324,13.359z\n  \t\t M100.949,38.319c6.391,0,12.15-5.4,13.021-11.844c0.871-6.441-3.431-11.791-9.826-11.791c-6.397,0-12.197,5.354-13.067,11.791\n  \t\tC90.207,32.915,94.555,38.319,100.949,38.319z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "projects-path",
    attrs: {
      "d": "M155.584,36.015c-1.207,8.928-7.106,13.805-16.148,13.805c-6.29,0-11.691-0.532-11.704-0.533\n  \t\tc-0.16-0.016-0.792-0.131-0.447-0.869l4.469-9.539c0.139-0.296,0.469-0.482,0.765-0.448c0,0,4.528,0.526,7.008,0.526\n  \t\tc2.491,0,4.556-1.359,5.113-5.485l3.898-28.829c0.054-0.4,0.468-0.662,0.752-0.662h9.963c0.401,0,0.611,0.378,0.573,0.662\n  \t\tL155.584,36.015z M149.774,5.304l-3.808,28.167c-0.632,4.671-3.386,6.81-6.618,6.81c-2.082,0-5.337-0.334-6.631-0.476l-3.858,8.235\n  \t\tc1.66,0.139,5.99,0.454,10.756,0.454c8.446,0,13.53-4.238,14.645-12.479l4.152-30.711H149.774z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "projects-path",
    attrs: {
      "d": "M190.549,13.386c-0.054,0.401-0.468,0.662-0.752,0.662h-14.388l-0.996,7.367h13.752c0.401,0,0.611,0.377,0.573,0.662\n  \t\tl-1.182,8.744c-0.054,0.4-0.468,0.662-0.752,0.662h-13.751l-1.01,7.473h14.388c0.401,0,0.611,0.377,0.573,0.662l-1.182,8.744\n  \t\tc-0.054,0.4-0.468,0.662-0.752,0.662h-25.013c-0.401,0-0.611-0.379-0.573-0.662l5.911-43.721c0.054-0.4,0.468-0.662,0.752-0.662\n  \t\th25.013c0.401,0,0.611,0.378,0.573,0.662L190.549,13.386z M166.629,5.304l-5.732,42.396h23.688l1.003-7.419H171.2\n  \t\tc-0.284,0-0.627-0.262-0.573-0.662l1.189-8.797c0.039-0.285,0.351-0.663,0.752-0.663h13.752l1.003-7.419h-13.752\n  \t\tc-0.284,0-0.627-0.262-0.573-0.662l1.175-8.691c0.039-0.284,0.351-0.662,0.752-0.662h14.388l1.003-7.42H166.629z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "projects-path",
    attrs: {
      "d": "M215.383,49.819c-12.681,0-22.956-10.32-21.209-23.238c1.753-12.965,14.775-23.396,27.514-23.396\n  \t\tc9.583,0,12.563,2.146,12.681,2.232c0.207,0.154,0.271,0.443,0.184,0.689l-3.445,9.805c-0.022,0.062-0.279,0.881-1.024,0.441\n  \t\tc0,0-3.42-2.039-8.363-2.039c-9.643,0-14.653,6.662-15.396,12.162c-0.751,5.555,2.459,12.215,12.101,12.215\n  \t\tc4.942,0,8.914-2.039,8.914-2.039c0.061-0.031,0.833-0.454,0.905,0.441l0.794,9.805c0.022,0.271-0.152,0.547-0.362,0.684\n  \t\tC228.486,47.698,224.931,49.819,215.383,49.819z M226.978,38.194c-1.49,0.623-4.831,1.82-8.732,1.82\n  \t\tc-10.39,0-14.085-7.33-13.246-13.539c0.833-6.158,6.511-13.487,16.9-13.487c3.888,0,6.838,1.161,8.24,1.821l2.986-8.498\n  \t\tc-0.955-0.488-4.218-1.803-11.617-1.803c-12.062,0-24.367,9.919-26.01,22.072c-1.636,12.096,8.049,21.913,20.063,21.913\n  \t\tc7.366,0,10.964-1.29,12.104-1.803L226.978,38.194z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "projects-path",
    attrs: {
      "d": "M239.142,4.642c0.055-0.4,0.468-0.662,0.752-0.662h30.736c0.401,0,0.611,0.378,0.573,0.662l-1.182,8.744\n  \t\tc-0.054,0.401-0.468,0.662-0.752,0.662h-9.725l-4.639,34.314c-0.054,0.4-0.468,0.662-0.752,0.662h-9.963\n  \t\tc-0.401,0-0.611-0.379-0.573-0.662l4.639-34.314h-9.724c-0.401,0-0.611-0.377-0.573-0.662L239.142,4.642z M249.099,12.724\n  \t\tc0.285,0,0.627,0.262,0.573,0.662l-4.64,34.313h8.638l4.639-34.313c0.039-0.284,0.351-0.662,0.752-0.662h9.725l1.003-7.42h-29.412\n  \t\tl-1.003,7.42H249.099z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "projects-path",
    attrs: {
      "d": "M288.717,38.754c2.567,0.009,4.146-0.86,4.451-3.11c0.808-5.975-17.135-7.705-15.683-18.441\n  \t\tc0.321-2.373,1.267-4.766,2.757-6.89c4.75-6.772,14.868-10.593,27.378-2.908c0.291,0.179,0.332,0.586,0.146,0.876l-5.103,7.949\n  \t\tc-0.053,0.082-0.475,0.77-1.053,0.199c-2.221-2.189-4.748-3.016-6.981-3.022c-3.396-0.011-5.803,1.827-6.019,3.425\n  \t\tc-0.492,3.639,18.605,5.455,16.878,18.229c-0.357,2.642-1.609,5.269-3.521,7.554c-6.126,7.322-18.985,11.114-31.629,1.309\n  \t\tc-0.254-0.197-0.284-0.588-0.07-0.881l6.114-8.373c0.211-0.29,0.642-0.465,0.978-0.203\n  \t\tC280.314,36.762,285.167,38.742,288.717,38.754z M271.704,43.187c12.156,9.088,24.001,5.168,29.433-1.517\n  \t\tc1.659-2.042,2.719-4.338,3.026-6.609c1.569-11.604-17.681-12.29-16.878-18.229c0.374-2.766,3.84-4.762,7.527-4.75\n  \t\tc2.361,0.008,4.899,0.792,7.224,2.811l4.264-6.643c-11.968-7.066-20.988-3.16-25.108,2.881c-1.284,1.883-2.102,3.992-2.383,6.072\n  \t\tc-1.256,9.293,16.75,10.552,15.684,18.441c-0.436,3.221-3.088,4.444-5.959,4.436c-3.753-0.013-8.391-1.868-11.546-4.129\n  \t\tL271.704,43.187z"
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paper-project-container clearfix"
  }, [_c('h3', [_vm._v("Paper")]), _vm._v(" "), _c('div', {
    staticClass: "left-text-container"
  }, [_c('p', [_c('strong', [_vm._v("TLDR:")]), _vm._v(" Paper is a financial news PWA which allows the user to follow companies listed on the NASDAQ. Up to five companies can be selected at once, with their 1 month historical prices charted, and the news feed customised to only return news pertaining to these shares.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The tech:")]), _vm._v(" This project is built with React and React Router. State and API calls are managed with Redux. The site is optimised as a PWA using webpack-pwa-plugin and service workers. The live project is hosted on Netlify.")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://github.com/andthomas/investment-app"
    }
  }, [_vm._v("View on GitHub")]), _vm._v(" | "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://paper-app.netlify.com/#/"
    }
  }, [_vm._v("Live Version")])]), _vm._v(" "), _c('img', {
    staticClass: "right",
    attrs: {
      "src": "https://res.cloudinary.com/djq5ic5br/image/upload/q_auto/fdsf_xcrdjz.gif",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "voyager-project-container clearfix",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('h3', [_vm._v("Outer Step")]), _vm._v(" "), _c('div', {
    staticClass: "right-text-container"
  }, [_c('p', [_c('strong', [_vm._v("TLDR:")]), _vm._v(" Outer Step is an Australian music festival. I built this website as a freelance developer to serve as a marketing and ticket sales platform. The site is optimised for fast loading times across browsers, while rich in assets and animations.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The tech:")]), _vm._v(" This project its built with Vue and hosted on Firebase. \n      It is integrated with Humanitix for ticket sales and Soundcloud for artist music samples.\n      Scroll animations were built using ScrollMagic and TweenMax.")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://outer-step-staging.firebaseapp.com/"
    }
  }, [_vm._v("Live Version")])]), _vm._v(" "), _c('img', {
    staticClass: "left",
    attrs: {
      "src": "https://res.cloudinary.com/djq5ic5br/image/upload/q_auto/outer_dswnet.gif",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-quick-project-container clearfix",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('h3', [_vm._v("Right Quick")]), _vm._v(" "), _c('div', {
    staticClass: "left-text-container"
  }, [_c('p', [_c('strong', [_vm._v("TLDR:")]), _vm._v(" Right Quick is a game to test your typing\n      skills with your right hand. I built this primarily as a rehabilitation\n      tool for people recoving from a stroke.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The tech:")]), _vm._v(" This project is built with Vue. It uses VueX,\n      ChartJS, and string-similarity.")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://github.com/andthomas/rightQuickTyping"
    }
  }, [_vm._v("View on GitHub")]), _vm._v(" | "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://andthomas.github.io/rightQuickTyping/#/"
    }
  }, [_vm._v("Live Version")])]), _vm._v(" "), _c('img', {
    staticClass: "right",
    attrs: {
      "src": "https://res.cloudinary.com/djq5ic5br/image/upload/q_auto/rightgif_gykgyc.gif",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fraga-project-container clearfix"
  }, [_c('h3', [_vm._v("Fråga")]), _vm._v(" "), _c('div', {
    staticClass: "right-text-container"
  }, [_c('p', [_c('strong', [_vm._v("TLDR:")]), _vm._v(" Fråga is the Swedish word for 'Ask'. The\n      project is a location based social media platform, where posts are\n      pinned to a specific location and can be commented on by people in that\n      area.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The tech:")]), _vm._v(" This project is built with Ruby on Rails.\n      Locations are detected by device and geocoded to a Google map.\n      Translations are handled with Yandex.")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://github.com/aparkinbotswana/Fraga"
    }
  }, [_vm._v("View on GitHub")]), _vm._v(" | "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://fraqa.herokuapp.com/"
    }
  }, [_vm._v("Live Version")])]), _vm._v(" "), _c('img', {
    staticClass: "left",
    attrs: {
      "src": "https://res.cloudinary.com/djq5ic5br/image/upload/q_auto/fraggif_g9qit0.gif",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agility-project-container clearfix"
  }, [_c('h3', [_vm._v("Agility")]), _vm._v(" "), _c('div', {
    staticClass: "left-text-container"
  }, [_c('p', [_c('strong', [_vm._v("TLDR:")]), _vm._v(" Agility is a retro styled game for the browser, inspired by Pong and Frogger. I built this in order to \n      try out a few new ES6 features including class syntax, destructuring and new array methods.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The tech:")]), _vm._v(" This project is built with Vanilla JS, HTML and CSS.")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://github.com/andthomas/agility"
    }
  }, [_vm._v("View on GitHub")]), _vm._v(" | "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://andthomas.github.io/agility/"
    }
  }, [_vm._v("Live Version")])]), _vm._v(" "), _c('img', {
    staticClass: "right",
    attrs: {
      "src": "https://res.cloudinary.com/djq5ic5br/image/upload/q_auto/agility_zt6vzf.gif",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-208e75d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Projects.vue
// module id = 47
// module chunks = 0